import Components from "../javascripts/components";

class UJSQueryCollection {
  constructor(...args) {
    this.setEl(...args);
  }

  setEl(...args) {
    this.$el = jQuery(...args).filter("*").slice(0, 1);
    this[0] = this.$el[0];
  }

  find(...args) {
    return new UJSQueryCollection(this.$el.find(...args));
  }

  html(...args) {
    return this.reloadComponents(() => this.$el.html(...args));
  }

  append(...args) {
    return this.insertComponents(() => this.$el.append(...args));
  }

  prepend(...args) {
    return this.insertComponents(() => this.$el.prepend(...args));
  }

  remove(...args) {
    return this.removeComponents(() => this.$el.remove(...args));
  }

  replaceWith(...args) {
    return this.reloadComponents(() => {
      const $oldEl = this.$el;
      this.setEl(...args);
      return $oldEl.replaceWith(this.$el);
    });
  }

  animate(...args) {
    return this.$el.animate(...args);
  }

  focus(...args) {
    return this.$el.focus(...args);
  }

  trigger(...args) {
    return this.$el.trigger(...args);
  }

  highlight() {
    this.$el.one("animationend", () => this.$el.removeClass("highlight-background"));
    return this.$el.addClass("highlight-background");
  }

  reloadComponents(fn) {
    Components.instances.unloadFragment(this.$el);
    fn();
    Components.collection.loadFragment(this.$el);
    return this;
  }

  removeComponents(fn) {
    Components.instances.unloadFragment(this.$el);
    fn();
    return this;
  }

  insertComponents(fn) {
    fn();
    Components.collection.loadFragment(this.$el);
    return this;
  }
}

window.ujsQuery = (...args) =>
  new UJSQueryCollection(...Array.from(args || []));
